import callApi from './partials/api';
import store from '@/store'

let getAdvancedSearchOption = (CompanyID, AreaID) => {
    if (!CompanyID) {
        let companyId = store.getters['advancedSearch/companyId'];
        if (companyId) {
            CompanyID = companyId;
        }
    }

    if (!AreaID) {
        let areaId = store.getters['advancedSearch/areaId'];
        if (areaId) {
            AreaID = areaId;
        }
    }

    return {
        CompanyID,
        AreaID,
    };
};

let getMemberOption = (MemberID) => {
    if (!MemberID) {
        let memberId = store.getters['user/MemberID'];
        if (memberId) {
            MemberID = memberId;
        }
    }

    return {
        MemberID,
    };
};

export default {
    // 課程搜尋
    search({ KeyWord, MemberID }, cb) {
        callApi('post', `Class/Search`, cb, {
            data: {
                KeyWord,
                ...getMemberOption(MemberID),
                companyId: store.getters['advancedSearch/companyId'],
            }
        });
    },

    // 課程分類
    queryClassification(cb) {
        callApi('post', `Class/QueryClassification`, cb,{
            data: {
                companyId: store.getters['advancedSearch/companyId'],
            }
        });
    },
    
    // 首頁(精選區)
    queryFeatured({ MemberID, CompanyID, AreaID }, cb) {
        callApi('post', `Class/QueryFeatured`, cb, {
            data: {
                ...getMemberOption(MemberID),
                ...getAdvancedSearchOption(CompanyID, AreaID),
            }
        });
    },

    // 首頁(新上架/熱門/預告區)
    queryNewHotPreparation({ MemberID, CompanyID, AreaID }, cb) {
        callApi('post', `Class/QueryNewHotPreparation`, cb, {
            data: {
                ...getMemberOption(MemberID),
                ...getAdvancedSearchOption(CompanyID, AreaID),
            }
        });
    },

    // 更多課程(依篩選條件顯示課程列表)
    queryList({ MemberID, FilterConditionID, TypeID, CurrentPage, PerPage, CompanyID, AreaID }, cb) {
        callApi('post', `Class/QueryList`, cb, {
            data: {
                ...getMemberOption(MemberID),
                FilterConditionID,
                TypeID,
                CurrentPage,
                PerPage,
                ...getAdvancedSearchOption(CompanyID, AreaID),
            }
        });
    },

    // 新增收藏
    addCollection({ InitID, MemberID }, cb) {
        callApi('post', `Class/AddCollection`, cb, {
            data: {
                InitID,
                ...getMemberOption(MemberID),
            }
        });
    },

    // 課程說明(內頁)
    queryExplanation({ InitID, MemberID }, cb) {
        callApi('post', `Class/QueryExplanation`, cb, {
            data: {
                InitID,
                ...getMemberOption(MemberID),
            }
        });
    },

    // 課程說明(推薦課程列表)
    queryRecommend({ ClassID, MemberID, CompanyID, AreaID }, cb) {
        callApi('post', `Class/QueryRecommend`, cb, {
            data: {
                ClassID,
                ...getMemberOption(MemberID),
                ...getAdvancedSearchOption(CompanyID, AreaID),
            }
        });
    },

    // 課程說明(價格及開課資訊)
    queryPrice({ InitID, MemberID, ClassBranchID }, cb) {
        callApi('post', `Class/QueryPrice`, cb, {
            data: {
                InitID,
                ClassBranchID,
                ...getMemberOption(MemberID),
            }
        });
    },

    // 立即報名(Step1 : 報名標題及區域選項)
    areaOption({ InitID, MemberID }, cb) {
        callApi('post', `Class/AreaOption`, cb, {
            data: {
                InitID,
                ...getMemberOption(MemberID),
            }
        });
    },

    // 立即報名(Step2 : 上課地點)
    locationOption({ InitID, MemberID, AreaID }, cb) {
        callApi('post', `Class/LocationOption`, cb, {
            data: {
                InitID,
                ...getMemberOption(MemberID),
                AreaID,
            }
        });
    },

    // 立即報名(Step3 : 上課日曆及時段)
    canendarOption({ InitID, MemberID, InquireMonth, BranchRoomID }, cb) {
        callApi('post', `Class/CanendarOption`, cb, {
            data: {
                InitID,
                ...getMemberOption(MemberID),
                InquireMonth,
                BranchRoomID,
            }
        });
    },

    // 進階搜尋
    advancedSearch(cb) {
        callApi('post', `Class/AdvancedSearch`, cb);
    },

    // 收藏課程清單
    queryCollectionList({ MemberID, TypeID, CurrentPage, PerPage }, cb) {
        callApi('post', `Class/QueryCollectionList`, cb, {
            data: {
                ...getMemberOption(MemberID),
                CurrentPage,
                PerPage,
                TypeID,
                CompanyID: store.getters['advancedSearch/companyId'],
            }
        });
    },
    
    // 日曆搜尋
    dateSearch({ QueryMonth }, cb) {
        callApi('post', `Class/DateSearch`, cb, {
            data: {
                QueryMonth,
                CompanyID: store.getters['advancedSearch/companyId'],
            }
        });
    },

    // 日曆搜尋結果課程頁面
    queryDateList({ MemberID, DateBegin, QueryDay, CurrentPage, PerPage, CompanyID, AreaID }, cb) {
        callApi('post', `Class/QueryDateList`, cb, {
            data: {
                ...getMemberOption(MemberID),
                DateBegin,
                QueryDay,
                CurrentPage,
                PerPage,
                ...getAdvancedSearchOption(CompanyID, AreaID),
            }
        });
    },
}
